var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plc-page",attrs:{"id":"app"}},[(_vm.load === 'success')?_c('router-view',{staticClass:"plc-page__main"}):(_vm.load === 'error')?_c('gl-message',{staticStyle:{"margin":"20px"},attrs:{"variant":"error","message":_vm.$t('Config cannot be loaded')}}):_c('gl-loader',{attrs:{"is-centered":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }